/** @format */

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import HeaderCheckBoxSelectList, { HeaderCheckBoxSelectListElement, HeaderListProps } from './HeaderCheckBoxSelectList';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { connect } from 'react-redux';
import ApiCollectionResponseInterface from '../../../../interfaces/api/ApiCollectionResponseInterface';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import MvnoBlockListInterface from '../../../../interfaces/platform/MvnoBlockListInterface';
import { provConstant } from '../../../../modules/provisioning/ProvisioningConnect';
import PlatformResellerInterface from '../../../../interfaces/platform/PlatformResellerInterface';

interface HeaderMvnoBlockListCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockListInterface> | null;
}

interface HeaderMvnoBlockListProps extends HeaderListProps {
    dispatch: any;
    platformResellerList: Array<PlatformResellerInterface>;
    nullable?: boolean;
}

interface HeaderMvnoBlockListState {
    items: Array<HeaderCheckBoxSelectListElement> | null;
}

class HeaderMvnoBlockList extends PureComponent<HeaderMvnoBlockListProps, HeaderMvnoBlockListState> {
    private loaderCall: ItemLoaders;

    constructor(props: HeaderMvnoBlockListProps, context: any) {
        super(props, context);
        this.state = {
            items: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
    }

    getPlatformResellerName = (platformResellerId: number, defaultGlobal: boolean): string | null => {
        const { platformResellerList } = this.props;
        if (!defaultGlobal) {
            for (let i = 0; i < platformResellerList.length; i++) {
                if (platformResellerList[i].id === platformResellerId) {
                    return '(' + platformResellerList[i].mainname + ')';
                }
            }
        }
        return null;
    };

    componentDidMount(): void {
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            provConstant.MVNO_BLOCK_LIST_LIST,
            [
                { name: 'deleted', value: false },
                { name: 'defaultGlobal', value: true },
                { name: 'pagination', value: false },
            ],
            [{ name: 'blockName', value: 'asc' }],
            (data: HeaderMvnoBlockListCollectionInterface): void => {
                let items = new Array<HeaderCheckBoxSelectListElement>();
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: MvnoBlockListInterface) => {
                        items.push({
                            name: 'prov:b.' + item.blockName,
                            value: item.id,
                            platformResellerName: this.getPlatformResellerName(item.platformResellerId, item.defaultGlobal),
                        });
                    });
                    this.setState({
                        items: items,
                    });
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }

    handleChange = (numbers: Array<number>): void => {
        const { handleChange, fieldName } = this.props;
        handleChange(fieldName, numbers, this.state.items);
    };

    render(): React.ReactNode {
        const { items } = this.state;
        const { fieldName, nullable } = this.props;
        if (items) {
            return <HeaderCheckBoxSelectList handleChange={this.handleChange} elements={items} nullable={nullable} fieldName={fieldName} />;
        }
        return null;
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(HeaderMvnoBlockList);
